module.exports = __webpack_public_path__ + "static/img/icon_img1.b03b2052.png";